export default {
  setapprovemsg: function setapprovemsg(data) {
    data = data || {};
    localStorage.setItem('$approvemsg', JSON.stringify(data));
  },
  getapprovemsg: function getapprovemsg() {
    var data = localStorage.getItem('$approvemsg') || "{}";
    return JSON.parse(data);
  },
  setuserinfor: function setuserinfor(data) {
    data = data || {};
    localStorage.setItem('$userinfor', JSON.stringify(data));
  },
  getuserinfor: function getuserinfor() {
    var data = localStorage.getItem('$userinfor') || "{}";
    return JSON.parse(data);
  },
  getuserId: function getuserId() {
    var data = localStorage.getItem('$userId') || "{}";
    return JSON.parse(data);
  },
  setuserId: function setuserId(data) {
    data = data || {};
    localStorage.setItem('$userId', JSON.stringify(data));
  },
  setFLOWLIST: function setFLOWLIST(data) {
    data = data || {};
    localStorage.setItem('$FLOWLIST', JSON.stringify(data));
  },
  getFLOWLIST: function getFLOWLIST() {
    var data = localStorage.getItem('$FLOWLIST') || "{}";
    return JSON.parse(data);
  },
  setuseDept: function setuseDept(data) {
    data = data || {};
    localStorage.setItem('$useDept', JSON.stringify(data));
  },
  getuseDept: function getuseDept() {
    var data = localStorage.getItem('$useDept') || "{}";
    return JSON.parse(data);
  }
};


// WEBPACK FOOTER //
// ./src/plugins/request/mylocalstore.js